module.exports = __webpack_public_path__ + "img/case-logo-04.1bb88f12.png";